import { createAction } from '@reduxjs/toolkit';
import { Bundling } from '../../data/bundling';

export const viewCatalogue = 'dora/viewCatalogue';
export const modularSofaCreate = 'dora/modularSofaCreate';
export const modularSofaConfigureExisting = 'dora/modularSofaConfigureExisting';
export const modularSofaUpdated = 'dora/modularSofaUpdated';
export const removedFurniture = 'dora/removedFurniture';
export const floorSizeChangeStart = 'dora/floorSizeChangeStart';
export const shareLinkCreated = 'dora/shareLinkCreated';
export const shareLinkCopied = 'dora/shareLinkCopied';
export const viewInAr = 'dora/viewInAr';
export const finalise = 'dora/finalise';
export const addToCart = 'dora/addToCart';
export const initialLoadingFinished = 'dora/finishedLoading';
export const exitViewShown = 'dora/exitViewShown';

export enum ConfigureButtonLocation {
    CONTEXT_MENU = 'context menu',
    ITEMS_LIST = 'items list',
}

// User views the product catalogue
export const viewCatalogueAction = createAction(viewCatalogue);

// Modular sofa
export const modularSofaCreateAction = createAction(modularSofaCreate);
export const modularSofaConfigureExistingAction = createAction<{ from: ConfigureButtonLocation }>(
    modularSofaConfigureExisting,
);
export const modularSofaUpdatedAction = createAction(modularSofaUpdated);

// Product remove (we need a special action for this because we need to know where the action originated...)
export const removedFurnitureAction =
    createAction<{ productIds: string[]; articles: string[]; from: ConfigureButtonLocation }>(
        removedFurniture,
    );

// Misc

/** Loading the initial scene has completed. Takes an optional Bundling describing the items in the scene at this time */
export const initialLoadingFinishedAction =
    createAction<{ bundling?: Bundling }>(initialLoadingFinished);
export const exitViewShownAction = createAction(exitViewShown);
export const floorSizeChangeStartAction = createAction(floorSizeChangeStart);
export const shareLinkCreatedAction = createAction<{
    location: 'items list' | 'close dialog' | 'ar-desktop';
    furnitureCount: number;
}>(shareLinkCreated);
export const shareLinkCopiedAction = createAction(shareLinkCopied);
export const viewInArAction = createAction<{ mode: 'simple' | 'advanced' }>(viewInAr);
export const finaliseAction =
    createAction<{ value: number; products: { productId: string; quantity: number }[] }>(finalise);
export const addToCartAction =
    createAction<{ value: number; products: { productId: string; quantity: number }[] }>(addToCart);
